import React from "react";
import { Link } from "react-router-dom";

const MasonryGallery = ({ title, subtitle, images, slug }) => {
  return (
    <section className="bg-neutral-900 py-24 lg:py-32">
      <div className="max-w-[1800px] mx-auto px-6 lg:px-12">
        
        {/* Title + Subtitle */}
        <div className="text-center mb-16">
          <span className="text-[#d4af37] text-xs tracking-[0.4em] block mb-4">
            {subtitle}
          </span>
          <h2 className="text-4xl lg:text-5xl text-white font-serif font-light">
            {title}
          </h2>
        </div>

        {/* Masonry Grid */}
        <div className="columns-2 md:columns-3 lg:columns-4 gap-4">
          {images.map((img, i) => (
            <div key={i} className="break-inside-avoid mb-4 cursor-hover group">
              <div className="relative overflow-hidden">
                <img
                  src={img}
                  alt={`Gallery ${i + 1}`}
                  className="w-full h-auto transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-[#d4af37]/0 group-hover:bg-[#d4af37]/10 transition-colors duration-500" />
              </div>
            </div>
          ))}
        </div>

        {/* ✅ Explore More Button (only if slug exists) */}
        {slug && (
          <div className="text-center mt-16">
            <Link
              to={slug}
              className="inline-block px-10 py-4 border border-[#d4af37] text-[#d4af37] tracking-widest text-sm hover:bg-[#d4af37] hover:text-black transition-all duration-300 cursor-hover"
            >
              EXPLORE MORE
            </Link>
          </div>
        )}
      </div>
    </section>
  );
};

export default MasonryGallery;
